import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { NGX_LOADING_BAR_IGNORED } from '@ngx-loading-bar/http-client';

export const LoadingBarInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  const shouldIgnore = req.headers.has('loadingBarIgnored');
  
  if (shouldIgnore) {
    req = req.clone({
        context: req.context.set(NGX_LOADING_BAR_IGNORED, true),
        headers: req.headers.delete('loadingBarIgnored')
    });
  }

  return next(req);
}